import { render } from "./MenuComponent.vue?vue&type=template&id=59c801be&ts=true"
import script from "./MenuComponent.vue?vue&type=script&lang=ts"
export * from "./MenuComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__